module.exports = __webpack_public_path__ + "media/images/application/choose-price/poulpe-02-a8afc0df62489c52601388200390b5ea.svg";